module.exports = __webpack_public_path__ + "static/media/carrot-down.daead7c3.svg";